import { useEffect, useState } from "react";
import { animate, motion } from "framer-motion";

const COLORS = {
  sky: { bar: "#0EA5E9", text: "text-sky-400", glow: "rgba(14,165,233,.4)", bg: "bg-sky-500/10" },
  emerald: { bar: "#10B981", text: "text-emerald-400", glow: "rgba(16,185,129,.4)", bg: "bg-emerald-500/10" },
  indigo: { bar: "#6366F1", text: "text-indigo-400", glow: "rgba(99,102,241,.4)", bg: "bg-indigo-500/10" },
  amber: { bar: "#F59E0B", text: "text-amber-400", glow: "rgba(245,158,11,.4)", bg: "bg-amber-500/10" },
  cyan: { bar: "#22D3EE", text: "text-cyan-400", glow: "rgba(34,211,238,.4)", bg: "bg-cyan-500/10" },
};

function useCountUp(value, decimals = 0) {
  const [v, setV] = useState(0);
  useEffect(() => {
    const c = animate(0, value, { duration: 1.2, ease: [.22, 1, .36, 1], onUpdate: (x) => setV(x) });
    return () => c.stop();
  }, [value]);
  return v.toLocaleString("id-ID", { maximumFractionDigits: decimals });
}

export default function StatCard({ icon: Icon, color = "sky", id, zh, value, suffix, pct, sub, delay = 0 }) {
  const v = useCountUp(value);
  const c = COLORS[color] || COLORS.sky;
  const tid = `kpi-${String(id).toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;
  return (
    <motion.div
      initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay, ease: [.22, 1, .36, 1] }}
      className="panel panel-hover p-4 relative overflow-hidden" data-testid={tid}
    >
      <div className="flex items-start justify-between gap-2">
        <div className={`flex h-9 w-9 items-center justify-center rounded ${c.bg}`}>
          <Icon className={`h-4.5 w-4.5 h-[18px] w-[18px] ${c.text}`} />
        </div>
        {pct != null && (
          <span className={`font-mono text-xs ${c.text}`}>{pct}%</span>
        )}
      </div>
      <div className="mt-3 text-xs text-slate-400 leading-snug">
        {id} <span className="cn text-slate-500">{zh}</span>
      </div>
      <div className="mt-1 font-mono text-2xl font-semibold text-slate-100 mono-nums" data-testid={`${tid}-value`}>
        {v} {suffix && <span className="text-sm text-slate-500 font-normal">{suffix}</span>}
      </div>
      <div className="rail mt-3">
        <motion.div className="rail-fill" style={{ background: c.bar, boxShadow: `0 0 12px ${c.glow}` }}
          initial={{ width: 0 }} animate={{ width: `${pct || 0}%` }} transition={{ duration: 1, delay: delay + 0.3, ease: [.22, 1, .36, 1] }} />
      </div>
      {sub && <div className="mt-2 text-[11px] text-slate-500">{sub}</div>}
    </motion.div>
  );
}